export * from "./script.service"
